import { useContext, useEffect, useState } from 'react';
import { Box, Breadcrumbs, Typography, Table, TableContainer, Paper, TableHead, TableRow, TableCell, TableBody, Pagination, Modal, TextField, Switch } from '@mui/material';
import { useParams } from 'react-router-dom';
// import { getById } from '../../../../services/masterService';
import { Container, MainContainer } from '../../../../components';
import { Menu } from '../Menu/Menu';
import RadiusButton from '../../../../components/RadiusButton'
import { useToaster } from '../../../../providers/ToasterProvider';
import dayjs from '../../../../config/dayjs';
import {
    getListByPage,
    getListAllByPage,
    // uploadCandidate,
} from '../../../../services/candidateListService';
import SEARCH_ICON from '../../../../assets/images/search-icon.svg';
import ARROW from '../../../../assets/images/breadcrumb-arrow.svg';
import ARROW_OPEN from '../../../../assets/images/breadcrumb-arrow-open.svg';
// ARROW_LEFT not used currently
// import ARROW_LEFT from '../../../../assets/images/back.svg';

import '../CandidateLists/CandidateLists.scss';
import { ProjectContext } from '../../../../providers/projectProvider';
// form validation for disable modal removed; keep imports commented until needed
// import { zodResolver } from '@hookform/resolvers/zod';
// import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { UploadCandidateListModal } from '../UploadCandidateListModal/UploadCandidateListModal';

let timer = null;
const columns = [
    { id: 'applicationNo', label: 'Application No', minWidth: 140 },
    { id: 'rollNo', label: 'Roll No', minWidth: 120 },
    { id: 'candidateName', label: 'Candidate Name', minWidth: 160 },
    { id: 'DoB(DD-MM-YYYY)', label: 'DoB(DD-MM-YYYY)', minWidth: 110 },
    { id: 'email', label: 'Email', minWidth: 140 },
    { id: 'mobileNumber', label: 'Mobile Number', minWidth: 140 },
    { id: 'venueId', label: 'Venue Id', minWidth: 140 },
    // { id: 'examHallName', label: 'Exam Hall Name', minWidth: 180 },
    // { id: 'serverId', label: 'Server Id', minWidth: 140 },
    { id: 'userName', label: 'UserName', minWidth: 140 },
    { id: 'password', label: 'Password', minWidth: 140 },
    { id: 'languages', label: 'Languages', minWidth: 140 },
    { id: 'scribeRequired', label: 'Scribe Required', minWidth: 140 },
    { id: 'nameofscribe', label: 'Name of Scribe', minWidth: 140 },
    { id: 'pwd(yes/no)', label: 'PWD (Yes/No)', minWidth: 140 },
    // { id: 'actions', label: 'Actions', minWidth: 140 },
];
const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT);
const disableSchema = z.object({
    reason: z.string().min(1, { message: 'Disable reason is required.' }),
});

export const CandidateLists = () => {
    const { projectDetails } = useContext(ProjectContext);
    const params = useParams();
    const projectName = params?.projectName;
    const [candidates, setCandidates] = useState([]);
    // const [candidateMasterId, setCandidateMasterId] = useState(null);
    const [candidateMaster, setCandidateMaster] = useState(null);
    const [maxPages, setMaxPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const { addNotification } = useToaster();
    const [search, setSearch] = useState('');
    const [newSearch, setNewSearch] = useState(false);
    const [candidatesChanged, setCandidateChanged] = useState(false);
    const [uploadCandidateModalVisible, setUploadCandidateModalVisible] = useState(false);


    const fetchRequiredData = async () => {
        try {
            const res = await getListAllByPage(search, currentPage, limit);
            if (res.code === 'OK') {
                const count = res.data.count;
                const rows = res.data.rows ?? [];
                setCandidates(rows.map((candidate) => {
                    const dateOfBirth = dayjs(candidate.dob);
                    candidate.dob = dateOfBirth.format('DD-MM-YYYY');
                    return candidate;
                }));
                const pages = Math.ceil(count / limit);
                setMaxPages(pages);
            } else {
                addNotification('Something bad happened on server.');
            }
        } catch (error) {
            console.log('There is an error while getting candidates list', error);
            addNotification('Something bad happened on server.');
        }
    }
    const onSearch = (e) => {
        setSearch(e.target.value);
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            setCurrentPage(1);
            setNewSearch(!newSearch);
        }, 400);
    }
    const handlePageChange = (e, value) => {
        setCurrentPage(value);
    };
    const onUploadCandidate = () => {
        setUploadCandidateModalVisible(true);
    }
    const renderCandidateCell = (columnId, rowIndex) => {
        const row = candidates[rowIndex];
        switch (columnId) {
            case 'applicationNo':
                return row?.applicationNo;

            case 'rollNo':
                return row?.rollNo;

            case 'candidateName':
                return row?.candidateName;

            case 'DoB(DD-MM-YYYY)':
                return row?.dob;

            case 'email':
                return row?.email;

            case 'mobileNumber':
                return row?.mobileNumber;

            case 'venueId':
                return row?.venueId;

            // case 'examHallName':
            //     return row?.examHall.hallName ;

            // case 'serverId':
            //     return row?.serverId ;

            case 'userName':
                return row?.userName;

            case 'password':
                return row?.password;
            case 'languages':
                return Array.isArray(row?.languages)
                    ? row.languages.join(', ')
                    : row?.languages;

            case 'scribeRequired':
                return row?.scribeRequired ? 'Yes' : 'No';

            case 'nameofscribe':
                return row?.scribeName;

            case 'pwd(yes/no)':
                return row?.pwd ? 'Yes' : 'No';
            default:
                return row[columnId];
        }
    }
    useEffect(() => {
        fetchRequiredData();
    }, [newSearch, currentPage, candidatesChanged]);

    return (
        <MainContainer sx={{ bgcolor: 'red' }}>
            <Menu>
                <Breadcrumbs aria-label="breadcrumb" separator='' sx={{ gap: 12 }}>
                    <Typography color="text.primary" sx={{ fontWeight: 400, textTransform: 'capitalize' }}>{projectDetails?.projectName}</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW} alt=''></img>
                    </Box>

                    <Typography color="text.primary" sx={{ fontWeight: 500 }}>Candidates List</Typography>
                    <Box sx={{ display: 'flex', alignContent: 'center' }}>
                        <img src={ARROW_OPEN} alt='' ></img>
                    </Box>
                </Breadcrumbs>
            </Menu>
            <Container sx={{
                display: 'flex',
                flexDirection: 'column'
            }}>
                <h1 className='title'>Candidates List</h1>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    columnGap: 2,
                    rowGap: 0.5,
                    mb: 1.5
                }}>
                    <RadiusButton sx={{
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        ml: 'auto'
                    }} color="secondary"
                        type="submit"
                        variant='contained'
                        disabled={!!candidateMaster?.enabledBy}
                        onClick={onUploadCandidate}
                    >
                        Upload Candidates
                    </RadiusButton>
                </Box>
                <Box style={{ border: '1px solid #BDBDBD' }}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        bgcolor: 'background.base',
                        px: 1.5,
                        py: 2
                    }}>
                    <div className="search-header-wrapper" style={{ marginBottom: 12 }}>
                        <div className='search-wrapper'>
                            <input type='text' className='search-box' value={search} onChange={onSearch} placeholder='Search...' />
                            <img className='search-icon' src={SEARCH_ICON} alt='' />
                        </div>
                    </div>
                    <Paper sx={{
                        width: '100%', 
                        overflow: 'hidden',
                        bgcolor: 'background.base',
                        maxHeight: 'calc(100vh - 305px)',
                        maxWidth: 'calc(100vw - 160px)',
                        borderRadius: 1,
                        mb: 4
                    }}>
                        <TableContainer sx={{
                            px: 1,
                            pb: 1,
                            maxHeight: 'inherit',
                            maxWidth: 'inherit',
                            border: '1px solid',
                            borderColor: 'primary.main',
                            borderRadius: 1
                        }}>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                sx={{
                                                    color: 'primary.main'
                                                }}
                                                key={column.id}
                                                align='center'
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!candidates?.length
                                        ? <TableRow sx={{ mx: 'auto', p: 2, color: 'grey.500' }}>
                                            <TableCell colSpan={columns.length} sx={{ border: 'none', textAlign: 'center' }}>
                                                No records available
                                            </TableCell>
                                        </TableRow>
                                        : candidates.map((row, rowIndex) => {
                                            return (
                                                <TableRow hover={false} role="checkbox" key={rowIndex}>
                                                    {columns.map((column, index) => {
                                                        return <TableCell key={column.id} align='center' sx={{
                                                            px: 1.5,
                                                            py: 0.75
                                                        }}>
                                                            {renderCandidateCell(column.id, rowIndex)}
                                                        </TableCell>
                                                    })}
                                                </TableRow>
                                            );
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                    <Pagination sx={{ mt: 'auto' }} count={maxPages} page={currentPage} onChange={handlePageChange} shape="rounded" />
                </Box>
                <UploadCandidateListModal
                    uploadCandidateModalVisible={uploadCandidateModalVisible}
                    setUploadCandidateModalVisible={setUploadCandidateModalVisible}
                    // uploadProcessingFn={uploadProcessingCandidate}
                    // uploadCandidateFn={uploadCandidate}
                    candidatesChanged={candidatesChanged}
                    setCandidatesChanged={setCandidateChanged}
                ></UploadCandidateListModal>
                {/* Disable status update modal */}
            </Container>
        </MainContainer >
    )
}